import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { persistStore } from 'redux-persist';
import persistConfig from './persistConfig';
import baseReducer from './reducers/base';
import userReducer from './reducers/user';
import adminUserReducer from './reducers/adminuser';
import measurementReducer from './reducers/measurement';
import intermediaryReducer from './reducers/intermediary';
import examinationsReducer from './reducers/examinations';
import bridgeDaysReducer from './reducers/bridge-days';
import dropdownReducer from './reducers/dropdown';
import studentsReducer from './reducers/students';
import documentReducer from './reducers/document';
import lecturersReducer from './reducers/lecturers';
import assessmentReducer from './reducers/assessment';
import dataCollectionReducer from './reducers/data-collection';
import carrierFeedbackReducer from './reducers/carrier-feedback';
import dashboardReducer from './reducers/dashboard';
import attendanceReducer from './reducers/attendance';
import trainingReportReducer from './reducers/training-report';
import liveWebinarReducer from './reducers/live-webinar';

const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedDropdownReducer = persistReducer(persistConfig, dropdownReducer);
const persistedDashboardReducer = persistReducer(persistConfig, dashboardReducer);
const persistedLecturersReducer = persistReducer(persistConfig, lecturersReducer);
const persistedBridgeDaysReducer = persistReducer(persistConfig, bridgeDaysReducer);
const persistedMeasurementReducer = persistReducer(persistConfig, measurementReducer);
const persistedIntermediaryReducer = persistReducer(persistConfig, intermediaryReducer);
const persistedExaminationsReducer = persistReducer(persistConfig, examinationsReducer);

export const store = configureStore({
    reducer: {
        base: baseReducer,
        students: studentsReducer,
        document: documentReducer,
        user: persistedUserReducer,
        adminUser: adminUserReducer,
        assessment: assessmentReducer,
        attendance: attendanceReducer,
        liveWebinar: liveWebinarReducer,
        dropdown: persistedDropdownReducer,
        lecturers: persistedLecturersReducer,
        dashboard: persistedDashboardReducer,
        trainingReport: trainingReportReducer,
        dataCollection: dataCollectionReducer,
        bridgeDays: persistedBridgeDaysReducer,
        carrierFeedback: carrierFeedbackReducer,
        measurement: persistedMeasurementReducer,
        intermediary: persistedIntermediaryReducer,
        examinations: persistedExaminationsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;